module.exports = __webpack_public_path__ + "img/shop.a20c6839.svg";